/* ==========================================================================
   MBC Bundles -- comportements custom greffés sur les widgets de l'app

   Migré le 2026-08-19 depuis le champ "Custom JS" de l'admin de l'app, pour que
   ce code vive dans le thème et soit versionné. Le champ de l'app doit rester
   VIDE, sinon le script tourne deux fois.

   Quatre rôles, tous basés sur le markup .mbc-* rendu par l'app :
     1. Réécrire le libellé du bouton d'ajout au panier en
        « Ajouter au panier — <prix final> <prix barré> », avec la remise
        abonnement appliquée quand elle est cochée (l'app ne l'affiche pas).
     2. Remplacer le pourcentage de remise des cartes d'offre par le montant
        réellement économisé (« 9 € d'économies »), plus parlant : remise
        produit + frais de livraison évités quand l'offre est en livraison
        offerte (état lu dans le CSS, cf. shippingSaved).
     3. Aligner la fréquence de livraison de l'abonnement sur la quantité
        choisie (2 unités -> livraison tous les 2 mois, etc.).
     4. Habiller chaque ligne d'offre (design « piste A », 2026-09-23) : prix au
        format français (« 21,90 € » et non « €21,90 »), libellé de quantité avec
        le nom de l'unité (« 2 crèmes » et non « 2 produits ») et ligne
        « 20,15 € l'unité · Livraison offerte » sous ce libellé (cf.
        renderOfferMeta ; le libellé de livraison vient du CSS).

   Chargé globalement depuis layout/theme.liquid, avec assets/mbc-bundles.css.
   Sans widget MBC sur la page, le script ne fait rien.
   ========================================================================== */
(function () {
  'use strict';

  var CONFIG = {
    /* Remise appliquée par l'app sur l'abonnement. Doit rester cohérent avec
       --mbc-subscription-badge dans mbc-bundles.css. */
    subscriptionDiscount: 0.1,

    /* Arrondi du montant économisé, à l'euro INFÉRIEUR : arrondir au supérieur
       annoncerait une remise plus forte que la remise réelle (3,02 € affichés
       4 €), ce qu'on ne veut pas sur un produit de santé. Sous 1 €, le montant
       exact est affiché. Remplacer par Math.ceil suffit à inverser la règle. */
    savingsRound: Math.floor,
    savingsSuffix: " d'économies",

    /* Frais de livraison comptés dans les économies d'une offre en livraison
       offerte. Valeur de secours seulement : le montant est lu dans le libellé
       CSS --mbc-shipping-paid (« Livraison 5,90 € »), unique endroit à éditer. */
    shippingCost: 5.9,

    /* Nom de l'unité par page produit, au singulier et au pluriel, pour le
       libellé de quantité (« 2 crèmes »). Clé = id du <body>, qui vaut
       `page_title | handle` (layout/theme.liquid) : le TITRE du produit passé au
       filtre handle, pas son handle Shopify (« & » devient « amp »). Sur une page
       absente d'ici, le libellé de l'app (« 2 produits ») est conservé. */
    unitNounByPage: {
      'la-creme-hemorroides': ['crème', 'crèmes'],
      'le-complement-circulation-amp-transit': ['boîte', 'boîtes'],
      'le-probiotique': ['boîte', 'boîtes'],
      'le-soin-lavant-hygiene-intime': ['flacon', 'flacons']
    },
    unitPriceSuffix: " l'unité",
    metaSeparator: ' · ',

    /* Quantité choisie -> option "fréquence de livraison" à présélectionner.
       Les valeurs sont les `value` des <option> du select de l'app (ids des
       selling plans Shopify) : à re-relever dans l'inspecteur si les plans
       d'abonnement sont recréés. */
    deliveryPlanByQty: {
      1: '690448302429', // tous les 1 mois
      2: '690450956637', // tous les 2 mois
      3: '690450989405' // tous les 3 mois
    }
  };

  var SEL = {
    root: '.mbc-bundle__wrapper, .mbc-bundle-vd',
    offer: '.mbc-bundle-vd__offer',
    offerRadio: '.mbc-bundle-vd__offer input[type="radio"]',
    offerPrice: '.mbc-bundle-vd__offer-price',
    offerComparePrice: '.mbc-bundle-vd__offer-compare-at-price',
    offerPercent: '.mbc-bundle-vd__offer-percent',
    offerHeader: '.mbc-bundle-vd__offer-header',
    offerDescription: '.mbc-bundle-vd__offer-description',
    offerMeta: '.mbc-offer-meta',
    offerBadgeText: '.mbc-bundle-vd__offer-badge-text',
    /* Conteneurs que l'app peint autour de la remise : `offer-discount` est la
       capsule posée à cheval sur le bord bas de la carte (fond accent à 25 %),
       `offer-badge` le ruban. */
    savingsHost: '.mbc-bundle-vd__offer-discount, .mbc-bundle-vd__offer-badge',
    subscriptionRadio: '.mbc-bundle__subscription input[type="radio"]',
    subscribeChecked: '.mbc-bundle__subscription input[value="subscribe"]:checked',
    planSelect: '.mbc-bundle__subscription .mbc-field__select',
    atc: '.mbc-bundle__atc',
    atcText: '.mbc-bundle__atc-text',
    atcFinalPrice: '.mbc-bundle__atc-final-price',
    atcOldPrice: '.mbc-bundle__atc-old-price'
  };

  /* ---------------------------------------------------------------- prix -- */

  /* Les prix de l'app sont du texte localisé ("18,90 €", "€18,90"). On lit le
     premier nombre venu ; la virgule est traitée comme séparateur décimal (FR). */
  function parsePrice(text) {
    var match = String(text).replace(/\s/g, '').match(/\d+(?:[.,]\d+)?/);
    return match ? parseFloat(match[0].replace(',', '.')) : NaN;
  }

  /* Réécrit `value` dans le format de `sample` (séparateur décimal et position
     du symbole monétaire), pour ne coder en dur ni « € » ni la virgule.
     `decimals` vaut 2 par défaut ; 0 donne « 3 € » plutôt que « 3,00 € ». */
  function formatLike(sample, value, decimals) {
    var separator = /\d([.,])\d/.exec(sample);
    var amount = value
      .toFixed(decimals === undefined ? 2 : decimals)
      .replace('.', separator ? separator[1] : ',');
    return String(sample).replace(/\d+(?:[.,]\d+)?/, amount);
  }

  /* « €21,90 » -> « 21,90 € » (espace insécable) quand le symbole précède le
     nombre ; un prix déjà au format français est rendu tel quel. */
  var SYMBOL_FIRST_RE = /^\s*([^\d\s.,]+)\s*(\d+(?:[.,]\d+)?)\s*$/;

  function frenchMoney(text) {
    var match = SYMBOL_FIRST_RE.exec(String(text));
    return match ? match[2] + '\u00a0' + match[1] : String(text).trim();
  }

  /* Valeur d'une variable CSS de type chaîne, sans ses guillemets et avec ses
     échappements décodés : Shopify minifie les assets et réécrit « € » en
     `\20ac ` dans les chaînes, que getPropertyValue rend tel quel. */
  function cssString(style, name) {
    return style
      .getPropertyValue(name)
      .trim()
      .replace(/^(['"])(.*)\1$/, '$2')
      .replace(/\\([0-9a-fA-F]{1,6})\s?/g, function (_, hex) {
        return String.fromCodePoint(parseInt(hex, 16));
      })
      .replace(/\\(.)/g, '$1');
  }

  /* ------------------------------------------------------------- sélection -- */

  function selectedOffer() {
    var radio = document.querySelector(SEL.offerRadio + ':checked');
    return radio ? radio.closest(SEL.offer) : null;
  }

  function selectedQty() {
    var radio = document.querySelector(SEL.offerRadio + ':checked');
    return radio ? radio.value : null;
  }

  function isSubscribed() {
    return !!document.querySelector(SEL.subscribeChecked);
  }

  /* --------------------------------------------------------- abonnement -- */

  /* Mémorise toujours la fréquence correspondant à la quantité, mais ne
     l'applique au select que si l'abonnement est coché (sinon on toucherait à un
     champ que le client ne voit pas). Au moment où il coche "Abonnement", la
     valeur mémorisée est appliquée d'un coup. */
  function syncDeliveryPlan(qty, apply) {
    var select = document.querySelector(SEL.planSelect);
    if (!select) return;

    var planValue = CONFIG.deliveryPlanByQty[qty] || select.dataset.mbcPlan;
    if (!planValue) return;

    select.dataset.mbcPlan = planValue;
    if (!apply || select.value === planValue) return;

    select.value = planValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---------------------------------------------------------- économies -- */

  var PERCENT_RE = /^\s*[-–−]?\s*\d+(?:[.,]\d+)?\s*%/;

  /* Nœud portant la remise d'une offre. `offer-percent` est toujours le
     pourcentage calculé par l'app. `offer-badge-text` est un ruban dont le
     libellé PEUT être un texte saisi par le marchand : on ne le reprend que
     s'il contient un pourcentage, pour ne jamais écraser un libellé métier
     (une fois repris, il est marqué et reste à nous). */
  function discountNode(offer) {
    var node = offer.querySelector(SEL.offerPercent);
    if (node) return node;

    node = offer.querySelector(SEL.offerBadgeText);
    if (!node) return null;
    if (!node.dataset.mbcSavings && !PERCENT_RE.test(node.textContent)) return null;
    node.dataset.mbcSavings = '1';
    return node;
  }

  /* Frais de livraison économisés par l'offre : le coût affiché sur le chip
     « Livraison 5,90 € » si l'offre est en livraison offerte, 0 sinon. L'état
     est celui que le CSS a décidé (--mbc-ship-label = --mbc-shipping-free, par
     index d'offre et par produit) : une seule source de vérité, le chip et le
     montant ne peuvent pas se contredire. */
  function shippingSaved(offer) {
    var style = getComputedStyle(offer);
    var label = style.getPropertyValue('--mbc-ship-label').trim();
    var free = style.getPropertyValue('--mbc-shipping-free').trim();
    if (!label || !free || label !== free) return 0;

    var cost = parsePrice(style.getPropertyValue('--mbc-shipping-paid'));
    return isNaN(cost) ? CONFIG.shippingCost : cost;
  }

  /* Retourne true si l'offre porte bien un chip d'économies, pour que l'appelant
     sache si la carte déborde vers le bas (cf. .mbc-has-savings côté CSS).
     Montant = remise produit (prix barré - prix) + livraison évitée. */
  function renderOfferSavings(offer) {
    var node = discountNode(offer);
    var priceEl = offer.querySelector(SEL.offerPrice);
    var compareEl = offer.querySelector(SEL.offerComparePrice);
    if (!node || !priceEl) return false;

    var product = compareEl
      ? parsePrice(compareEl.textContent) - parsePrice(priceEl.textContent)
      : 0;
    if (isNaN(product) || product < 0) product = 0;

    var saved = product + shippingSaved(offer);
    if (saved <= 0) return false;
    var sample = (compareEl || priceEl).textContent;

    /* Le chip est peint sur le nœud texte via notre classe, et le conteneur
       que l'app dessine autour est aplati : il porte son propre fond, qui
       sinon réapparaît derrière le chip. Quand la remise est remplacée par un
       libellé marchand, l'app rend `offer-label` au lieu du pourcentage : on
       n'arrive jamais ici, et sa capsule reste intacte. */
    node.classList.add('mbc-savings');
    var host = node.closest(SEL.savingsHost);
    if (host) host.classList.add('mbc-savings-host');

    var amount =
      saved >= 1
        ? formatLike(sample, CONFIG.savingsRound(saved), 0)
        : formatLike(sample, saved);
    var text = amount + CONFIG.savingsSuffix;

    /* Écriture conditionnelle : sinon nos propres mutations relanceraient
       l'observer en boucle. */
    if (node.textContent.trim() !== text) node.textContent = text;
    return true;
  }

  /* ------------------------------------------------------- ligne d'offre -- */

  /* Prix au format français. À faire AVANT le chip d'économies et le bouton,
     qui recopient le texte de ces nœuds. Écriture conditionnelle (observer). */
  function renderOfferPrices(offer) {
    var nodes = offer.querySelectorAll(SEL.offerPrice + ', ' + SEL.offerComparePrice);
    for (var i = 0; i < nodes.length; i++) {
      var text = frenchMoney(nodes[i].textContent);
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  /* Libellé « 2 crèmes » + ligne « 20,15 € l'unité · Livraison offerte ».
     La ligne est un <span> à nous, inséré après le libellé de l'app ; l'app le
     perd quand elle re-rend la carte, et l'observer nous ramène ici. */
  function renderOfferMeta(offer) {
    var radio = offer.querySelector('input[type="radio"]');
    var description = offer.querySelector(SEL.offerDescription);
    var priceEl = offer.querySelector(SEL.offerPrice);
    if (!radio || !description || !priceEl) return;

    var qty = parseInt(radio.value, 10);
    var price = parsePrice(priceEl.textContent);
    if (!(qty > 0) || isNaN(price)) return;

    var noun = CONFIG.unitNounByPage[document.body.id];
    if (noun) setText(description, qty + ' ' + noun[qty > 1 ? 1 : 0]);

    var style = getComputedStyle(offer);
    var shipLabel = cssString(style, '--mbc-ship-label');
    var free = shipLabel && shipLabel === cssString(style, '--mbc-shipping-free');

    var meta = offer.querySelector(SEL.offerMeta);
    if (!meta) {
      meta = document.createElement('span');
      meta.className = 'mbc-offer-meta';
      meta.innerHTML =
        '<span class="mbc-offer-meta__unit"></span>' +
        '<span class="mbc-offer-meta__sep"></span>' +
        '<span class="mbc-offer-meta__ship"></span>';
      description.insertAdjacentElement('afterend', meta);
    }

    setText(
      meta.querySelector('.mbc-offer-meta__unit'),
      formatLike(priceEl.textContent, price / qty) + CONFIG.unitPriceSuffix
    );
    setText(meta.querySelector('.mbc-offer-meta__sep'), shipLabel ? CONFIG.metaSeparator : '');
    var ship = meta.querySelector('.mbc-offer-meta__ship');
    setText(ship, shipLabel);
    ship.classList.toggle('is-free', !!free);
  }

  function renderOffers() {
    var offers = document.querySelectorAll(SEL.offer);

    for (var i = 0; i < offers.length; i++) {
      renderOfferPrices(offers[i]);
      renderOfferMeta(offers[i]);
      /* toggle et non add : une offre peut perdre sa remise (changement de
         variante). Les mutations d'attribut ne réveillent pas l'observer, qui
         n'écoute pas `attributes`. */
      offers[i].classList.toggle('mbc-has-savings', renderOfferSavings(offers[i]));
    }
  }

  /* ------------------------------------------------------------- bouton -- */

  /* L'app rend un bouton au libellé simple ; on le remplace par une structure
     libellé + prix. Le libellé d'origine est relu à chaque reconstruction, donc
     un changement de traduction côté app est repris automatiquement. */
  function ensureTemplate(button) {
    if (button.querySelector(SEL.atcText)) return;

    var label = (button.textContent || '').trim();
    button.innerHTML =
      '<span class="mbc-bundle__atc-label">' +
      '<span class="mbc-bundle__atc-text"></span>' +
      '<span class="mbc-bundle__atc-dot">—</span>' +
      '<span class="mbc-bundle__atc-prices">' +
      '<span class="mbc-bundle__atc-final-price"></span>' +
      '<span class="mbc-bundle__atc-old-price"></span>' +
      '</span>' +
      '</span>';
    button.querySelector(SEL.atcText).textContent = label;
  }

  var lastRendered = null;

  function renderButton() {
    var button = document.querySelector(SEL.atc);
    var offer = selectedOffer();
    var priceEl = offer && offer.querySelector(SEL.offerPrice);
    if (!button || !priceEl) return;

    var price = parsePrice(priceEl.textContent);
    if (isNaN(price)) return;

    var compareEl = offer.querySelector(SEL.offerComparePrice);
    var comparePrice = compareEl ? parsePrice(compareEl.textContent) : price;
    var discounted = isSubscribed();
    if (discounted) price *= 1 - CONFIG.subscriptionDiscount;

    /* Le MutationObserver reçoit aussi nos propres écritures : on ne réécrit
       que si l'état affiché a changé (ou si l'app a ré-injecté son bouton),
       ce qui coupe la boucle observer -> écriture -> observer. */
    var state = price + '|' + comparePrice;
    if (state === lastRendered && button.querySelector(SEL.atcText)) return;
    lastRendered = state;

    ensureTemplate(button);
    button.querySelector(SEL.atcFinalPrice).textContent = discounted
      ? formatLike(priceEl.textContent, price)
      : priceEl.textContent.trim();

    var oldPriceEl = button.querySelector(SEL.atcOldPrice);
    var showOldPrice = comparePrice > price + 0.001;
    oldPriceEl.textContent = showOldPrice ? compareEl.textContent.trim() : '';
    oldPriceEl.style.display = showOldPrice ? '' : 'none';
  }

  /* --------------------------------------------------------- observation -- */

  var renderScheduled = false;

  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    requestAnimationFrame(function () {
      renderScheduled = false;
      renderOffers();
      renderButton();
    });
  }

  /* L'app injecte son widget après le chargement : on observe <body> jusqu'à ce
     que le widget existe, puis on se rebranche dessus pour limiter le bruit. */
  var observer = new MutationObserver(onMutation);
  var observedRoot = null;

  function observeWidget() {
    if (observedRoot && observedRoot !== document.body) return;

    var root = document.querySelector(SEL.root) || document.body;
    if (root === observedRoot) return;

    observer.disconnect();
    observedRoot = root;
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: root !== document.body
    });
  }

  function onMutation() {
    observeWidget();
    scheduleRender();
  }

  /* ---------------------------------------------------------------- init -- */

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.matches !== 'function') return;

    if (target.matches(SEL.offerRadio)) {
      syncDeliveryPlan(target.value, isSubscribed());
    } else if (target.matches(SEL.subscriptionRadio)) {
      if (target.value === 'subscribe') syncDeliveryPlan(selectedQty(), true);
    } else {
      return;
    }

    scheduleRender();
  });

  syncDeliveryPlan(selectedQty(), isSubscribed());
  observeWidget();
  scheduleRender();
})();
